/**
 * 构建树形结构
 *
 * @param tags 标签数组
 * @param parentId 父级ID，默认为0
 * @returns 返回构建好的树形结构数组
 */
const buildTree = (tags, parentId = 0) => {
  // 初始化树形结构
  let tree = []

  // 遍历标签数组
  for (let tag of tags) {
    // 如果当前标签的父级ID等于给定的父级ID
    if (tag.pid === parentId) {
      // 递归调用buildTree函数，构建当前标签的子树
      const children = buildTree(tags, tag.id)

      // 如果子树不为空
      if (children.length) {
        // 将子树赋值给当前标签的children属性
        tag.children = children
      }

      // 将当前标签添加到树形结构中
      tree.push(tag)
    }
  }

  // 返回构建好的树形结构
  return tree
}

export default buildTree